import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function RankingSection() {
  const topComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            人气排行
          </h2>
          <p className="text-sm text-foreground-600 mt-3">最受欢迎的韩漫作品排名</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {topComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/60 transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 font-bold text-lg" style={{ fontFamily: "var(--font-heading)" }}>
                {index + 1}
              </div>
              <div className="w-14 h-20 flex-shrink-0 rounded overflow-hidden">
                <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1 whitespace-nowrap">{comic.author}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.category === "romance" ? "恋爱言情" : comic.category === "fantasy" ? "奇幻冒险" : comic.category === "action" ? "热血动作" : comic.category === "thriller" ? "悬疑惊悚" : comic.category === "comedy" ? "搞笑日常" : comic.category === "drama" ? "剧情深度" : comic.category === "historical" ? "古风历史" : "BL耽美"}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.chapters}话</span>
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                  <span className="text-xs font-semibold whitespace-nowrap">{(comic.views / 10000).toFixed(0)}万</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}